import { type User } from 'vivaa-api';

import { isDefined, isTruthy } from '../utils/types.js';

export function getLoginRedirectUrl(baseUrl: string): string {
  const params = new URLSearchParams();
  params.append('redirectSuccess', window.location.href.replace(/\/logout$/, ''));
  return `${baseUrl}?${params}`;
}

/**
 * Get the user's name in `firstName lastName` format
 * If the user has no first name then only return the last name and vice versa.
 * If both names are missing, return the user's email.
 */
export function getUserDisplayNameOrEmail(user: User.UserBasic): string {
  const userName = [user.firstName, user.lastName].filter(isDefined).join(' ');
  return isTruthy(userName) ? userName : user.email;
}
